export default "__VITE_ASSET__aed17852__"